var _a;
import * as u from '@virtuoso.dev/urx';
export var LogLevel;
(function (LogLevel) {
    LogLevel[LogLevel["DEBUG"] = 0] = "DEBUG";
    LogLevel[LogLevel["INFO"] = 1] = "INFO";
    LogLevel[LogLevel["WARN"] = 2] = "WARN";
    LogLevel[LogLevel["ERROR"] = 3] = "ERROR";
})(LogLevel || (LogLevel = {}));
var CONSOLE_METHOD_MAP = (_a = {},
    _a[LogLevel.DEBUG] = 'debug',
    _a[LogLevel.INFO] = 'log',
    _a[LogLevel.WARN] = 'warn',
    _a[LogLevel.ERROR] = 'error',
    _a);
var getGlobalThis = function () {
    return typeof globalThis === 'undefined' ? window : globalThis;
};
export var loggerSystem = u.system(function () {
    var logLevel = u.statefulStream(LogLevel.ERROR);
    var log = u.statefulStream(function (label, message, level) {
        if (level === void 0) { level = LogLevel.INFO; }
        var _a;
        var currentLevel = (_a = getGlobalThis()['VIRTUOSO_LOG_LEVEL']) !== null && _a !== void 0 ? _a : u.getValue(logLevel);
        if (level >= currentLevel) {
            // eslint-disable-next-line no-console
            console[CONSOLE_METHOD_MAP[level]]('%creact-virtuoso: %c%s %o', 'color: #0253b3; font-weight: bold', 'color: initial', label, message);
        }
    });
    return {
        log: log,
        logLevel: logLevel,
    };
}, [], { singleton: true });
